import React, { useState } from "react";
import { Box, Grid, FormControl, Typography } from "@mui/material";
import ButtonComponent from "./ButtonComponent";
import { COLORS } from "../config/theme";
import { useAuth } from "../hooks";
import { responderSms } from "../services/sms.service"; // Restaurado
import CustomTextarea from "./CustomTextarea";

export default function ResponderMensaje({
  setReload,
  reload,
  setIsVisibleModal,
  mensaje,
  respuesta,
}) {
  const { user } = useAuth();
  const [message, setMessage] = useState("");

  const onClose = () => {
    setIsVisibleModal(false);
    setMessage("");
  };

  const handleCreateMessageClick = async () => {
    let data = {
      respuesta: message,
      respuesta_usu: user.id_usuario,
      respuesta_fec: new Date(),
      leido: 1
    };

    try {
      const result = await responderSms(data, respuesta);

      console.log("resultado al crear mensaje:", result);

      if (result.data) {
        setReload(!reload);
        setIsVisibleModal(false);
        setMessage("");
      }
    } catch (error) {
      console.log("error create request exp", error);
    }
  };

  const handleInputChangeMessage = (event) => {
    const value = event.target ? event.target.value : event;
    setMessage(value);
  };

  return (
    <>
      <Box p={2}>
        <Grid container spacing={2}>
          {/* Sección del Mensaje Original */}
          <Grid item xs={12}>
            <Box
              sx={{
                border: `1px solid ${COLORS.GRAY_LIGHT}`,
                borderRadius: "4px",
                padding: "8px",
                backgroundColor: COLORS.GRAY_VERY_LIGHT,
              }}
            >
              <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                Mensaje Original
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {mensaje}
              </Typography>
            </Box>
          </Grid>

          {/* Sección de Respuesta */}
          <Grid item xs={12}>
            <FormControl fullWidth variant="outlined" size="small">
              <CustomTextarea
                rows={4}
                value={message}
                onChange={handleInputChangeMessage}
                label="Respuesta"
              />
            </FormControl>
          </Grid>

          {/* Botones */}
          <Grid item xs={12}>
            <Box display="flex" justifyContent="space-between">
              <ButtonComponent
                name="Enviar"
                toAction={handleCreateMessageClick}
              />
              <div style={{ width: "5px" }}></div>
              <ButtonComponent
                name="Cancelar"
                toAction={onClose}
                color={COLORS.DANGER}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
